/**
 * Trainer ↔ trainer fan-out for "Topic time completed" modal decisions.
 * When any trainer Applies (Completed / +10m / Skip), every other trainer
 * closes the modal and applies the same action.
 */

import type { TopicManageAction } from "./ManageTopicModal";

export const LIVE_TOPIC_MANAGE_TYPE = "codelive.topic-manage" as const;

export type LiveTopicManageMessage = {
  type: typeof LIVE_TOPIC_MANAGE_TYPE;
  v: 1;
  action: TopicManageAction;
  /** Topic or subtopic id the modal was about. */
  segment_id: string;
  topic_id?: string;
  at: number;
  by?: string;
};

export function encodeLiveTopicManage(
  msg: Omit<LiveTopicManageMessage, "type" | "v">,
): Uint8Array<ArrayBuffer> {
  const payload: LiveTopicManageMessage = {
    type: LIVE_TOPIC_MANAGE_TYPE,
    v: 1,
    ...msg,
  };
  return new TextEncoder().encode(
    JSON.stringify(payload),
  ) as Uint8Array<ArrayBuffer>;
}

export function decodeLiveTopicManage(
  data: Uint8Array,
): LiveTopicManageMessage | null {
  try {
    const raw = JSON.parse(new TextDecoder().decode(data)) as Partial<
      LiveTopicManageMessage
    >;
    if (raw?.type !== LIVE_TOPIC_MANAGE_TYPE || raw.v !== 1) return null;
    const action = raw.action;
    if (
      action !== "completed" &&
      action !== "more-time" &&
      action !== "skip"
    ) {
      return null;
    }
    const segmentId = String(raw.segment_id || "").trim();
    if (!segmentId) return null;
    return {
      type: LIVE_TOPIC_MANAGE_TYPE,
      v: 1,
      action,
      segment_id: segmentId,
      topic_id: raw.topic_id ? String(raw.topic_id) : undefined,
      at: Number(raw.at || Date.now()),
      by: raw.by ? String(raw.by) : undefined,
    };
  } catch {
    return null;
  }
}
